import { combineReducers } from "redux";

//common slices
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import statusListSlice from "./slices/statusListSlice";
import commentListSlice from "./slices/commentListSlice";
import commentCreateSlice from "./slices/commentCreateSlice";
import firebaseNotificationSlice from "./slices/firebaseNotificationSlice";
import PermissionSlice from "../store/slices/permissionSlice";
import MyDetailSlice from "../store/slices/userDetailsSlice";
import countStatusSlice from "../store/slices/countStatusSlice";
import rewardStatusListSlice from "./slices/rewardStatusListSlice";
import rewardCategoryListSlice from "./slices/rewardCategoryListSlice";

//module slices
import * as authSlices from "../views/auth-views/config/reducer";
import * as rewardCatalogSlices from "../views/reward-views/catalog/config/reducer";
import * as segmentPricebookSlices from "../views/reward-views/catalog/segmentPricebook/redux/reducer";
import * as rewardSupplyChainSlices from "../views/reward-views/supply-chain/config/reducer";
import * as rewardPaymentsSlices from "../views/reward-views/payments/config/reducer";
import * as rewardSettingsSlices from "../views/reward-views/settings/config/reducer";
import * as rewardUserSlices from "../views/reward-views/users/config/reducer";
import * as rewardSalesSlices from "../views/reward-views/sales/config/reducer";
import * as rewardPermissionSlices from "../views/admin-views/permission/config/reducer";
import * as rewardLogsSlices from "../views/reward-views/logs/config/reducer";
import * as rewardWarehouseSlices from "../views/reward-views/warehouse/config/reducer";
import * as rewardTargetsSlices from "../views/reward-views/targets/config/reducer";
import * as rewardSalesPlanSlices from "../views/reward-views/sales-plan/config/reducer";
import * as rewardApprovalsSlices from "../views/reward-views/approvals/config/reducer";
import * as rewardDistributionSlices from "../views/reward-views/distribution/config/reducer";
import * as rewardReplenishmentSlices from "../views/reward-views/replenishment/config/reducer";
import * as rewardLeadSlices from "../views/reward-views/lead/config/reducer";
import * as rewardOrderRequestSlices from "../views/reward-views/order-requests/config/reducer";

const rootReducer = (asyncReducers) => (state, action) => {
	const combinedReducer = combineReducers({
		theme,
		auth,
		MyDetailSlice,
		PermissionSlice,
		statusListSlice,
		commentListSlice,
		commentCreateSlice,
		firebaseNotificationSlice,
		countStatusSlice,
		rewardStatusListSlice,
		rewardCategoryListSlice,
		...asyncReducers,
		...authSlices,
		...rewardCatalogSlices,
		...segmentPricebookSlices,
		...rewardSupplyChainSlices,
		...rewardPaymentsSlices,
		...rewardSettingsSlices,
		...rewardUserSlices,
		...rewardSalesSlices,
		...rewardPermissionSlices,
		...rewardLogsSlices,
		...rewardWarehouseSlices,
		...rewardTargetsSlices,
		...rewardSalesPlanSlices,
		...rewardApprovalsSlices,
		...rewardDistributionSlices,
		...rewardReplenishmentSlices,
		...rewardLeadSlices,
		...rewardOrderRequestSlices,
	});
	return combinedReducer(state, action);
};

export default rootReducer;
